import { observer } from 'mobx-react';

import SteppedComponent from 'js/components/pages/SteppedComponent';
import AppUser from 'js/stores/AppUser';
import AppState from 'js/stores/AppState';
import analytics from 'js/services/Analytics';
import { lightGrey1Color } from 'js/config/style';
import { validPrice, validQuantity } from 'js/services/Regex';
import { url } from 'js/services/Network';

import CreatePaymentLinkPageState from 'js/stores/pages/CreatePaymentLinkPageState';

import ItemDetails from './ItemDetails';
import SizeDetails from './SizeDetails';
import PickupDetails from './PickupDetails';
import SignUpSignIn from './SignUpSignIn';

@observer
export default class CreatePaymentLinkPage extends SteppedComponent {
  pageName = 'CreatePaymentLinkPage';
  trackingName = 'SP_create_link';
  pageColor = lightGrey1Color;

  bootstrap = () => this.page.load();


  pageEvent = () => {
    // window.location.replace('create-new-link')
    const params = new URLSearchParams(window.location.search);
    if (params.has('cv')) {
      analytics.goal('landing_conversion');
      // analytics.track('LP_clicked through', {
      //   location_on_page: params.get('s'),
      // });
    }
  };

  backNav = () =>
    AppUser.isLoggedIn
      ? AppState.previousPage === 'UserDashboardPage'
        ? {
            mode: 'back',
            text: 'Dashboard',
            url: url('user-dashboard-page'),
          }
        : {
            mode: 'back',
            text: 'My items',
            url: url('my-items-page'),
          }
      : { mode: 'normal' };

  page = CreatePaymentLinkPageState.create().setSteps(this, 'create-payment-link-page', [
    {
      name: 'item',
      label: 'Item',
      component: ItemDetails,
      completed: paymentLink => !!(paymentLink.title && validPrice(page.price) && validQuantity(page.quantity)),
      onEnter: () => { analytics.page('CTA_SP_create_link_continue_details') },
      showStepMenu: true,
    },
    {
      name: 'size',
      label: 'Size',
      component: SizeDetails,
      completed: paymentLink => !!paymentLink.size,
      onEnter: () => { analytics.page('CTA_SP_create_link_size_details') },
      showStepMenu: true,
    },
    {
      name: 'pickup-details',
      label: 'Pick-up details',
      component: PickupDetails,
      isComplete: (page, step) => page.address.hasAddress,
      onEnter: () => { analytics.page('CTA_SP_create_link_pickup_details') },
      showStepMenu: true,
    },
    {
      name: 'signup',
      label: 'Sign up',
      component: SignUpSignIn,
      onEnter: (page, step) => {
        page.setWithSignup(true);
        analytics.page('CTA_SP_create_link_signup')
      },
      skipWhen: (page, step) => {
        page.setWithSignup(false);
        return AppUser.isLoggedIn;
      },
    },
  ]);
}
